import React from 'react';
// import { Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import { logout } from '../actions/userActions';

const Header = () => {
  const dispatch = useDispatch();

  const userLogin = useSelector(state => state.userLogin);
  const { userInfo } = userLogin;

  const logoutHandler = () => {
    dispatch(logout());
  };

  return (
    <header>
      <Navbar
        collapseOnSelect
        expand='lg'
        variant='dark'
        sticky='bottom'
        className='color-nav'
      >
        <Container>
          <Navbar.Brand href='/' style={{ padding: 0 }}>
            <img
              src='/flex-logo.jpg'
              width='275'
              height='100%'
              className='d-inline-block align-top'
              alt='FLEXible logo'
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls='responsive-navbar-nav' />
          <Navbar.Collapse id='responsive-navbar-nav'>
            <Nav className='ml-auto'>
              <Nav.Link href='/classes'>Classes</Nav.Link>
              <Nav.Link href='/spaces'>Spaces</Nav.Link>
              <NavDropdown title='People' id='collasible-nav-dropdown'>
                <NavDropdown.Item href='/classes'>Clients</NavDropdown.Item>
                <NavDropdown.Item href='/classlist'>Trainers</NavDropdown.Item>
                <NavDropdown.Item href='/spacelist'>
                  Gym Owners
                </NavDropdown.Item>
              </NavDropdown>
              {userInfo ? (
                <NavDropdown title={userInfo.name} id='username'>
                  <LinkContainer to='/profile'>
                    <NavDropdown.Item>Profile</NavDropdown.Item>
                  </LinkContainer>
                  <NavDropdown.Item onClick={logoutHandler}>
                    Logout
                  </NavDropdown.Item>
                </NavDropdown>
              ) : (
                <LinkContainer to='/login'>
                  <Nav.Link>
                    <i className='fas fa-user'></i> Sign In
                  </Nav.Link>
                </LinkContainer>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
